import { Divider, Modal, Typography } from 'antd'
import React from 'react'
import { useSelector } from 'react-redux'
import { getMaterialImage } from '../../../../../api/materials'
import { selectUser } from '../../../../../redux/user'

const PhotoModal = ({ visible, onClose, material, noInfo }) => {
  const [image, setImage] = React.useState(undefined)
  const { user } = useSelector(selectUser)

  const normalizeImageSrc = payload => {
    if (!payload) return undefined

    let src = payload
    if (typeof payload === 'object') {
      src = payload?.url ?? payload?.data ?? payload?.image ?? payload?.base64
    }
    if (typeof src !== 'string') return undefined

    const trimmed = src.trim()
    if (!trimmed) return undefined

    // Already a data URL or a normal URL.
    if (
      trimmed.startsWith('data:') ||
      trimmed.startsWith('http://') ||
      trimmed.startsWith('https://') ||
      trimmed.startsWith('/')
    ) {
      return trimmed
    }

    // If backend returns raw base64 without prefix, assume PNG.
    return `data:image/png;base64,${trimmed}`
  }

  React.useEffect(() => {
    if (visible && material?._id) {
      getMaterialImage(material?._id)
        .then(({ data }) => setImage(normalizeImageSrc(data)))
        .catch(e => {
          console.warn(e)
          setImage(undefined)
        })
    } else if (!visible) {
      setImage(undefined)
    }
  }, [visible, material?._id])

  return (
    <Modal
      title={material?.name}
      open={visible}
      footer={null}
      onCancel={onClose}
      width={'50%'}>
      {visible && (
        <>
          {!noInfo && (
            <>
              <Typography.Title level={5}>{user?.companyName}</Typography.Title>
              {user?.userAssociated && (
                <Typography.Text>Associato ASMAVE</Typography.Text>
              )}

              <Divider />
            </>
          )}
          {image ? (
            <img
              alt={material?.name || 'Immagine'}
              src={image}
              style={{ width: '100%', height: 'auto', display: 'block' }}
            />
          ) : (
            <Typography.Text type="danger">
              Non è presente nessuna immagine!
            </Typography.Text>
          )}
        </>
      )}
    </Modal>
  )
}

export default PhotoModal
